<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<template>
  <div :class="['colorBox', 'color' + color]" />
</template>

<style lang="scss">
@import '@design';

.colorBox {
  width: 120px;
  height: 120px;
  margin-right: 1rem;
  border: solid 1px $white;
}

.colorPrimary {
  background: $primary;
}

.colorPrimaryLighter {
  background: $primary-lighter;
}

.colorPrimaryDarker {
  background: $primary-darker;
}

.colorWhite {
  background: $white;
}

.colorOrange {
  background: $orange;
}
</style>
